<script setup>
import { ref, reactive, computed, onMounted, watch } from 'vue'
import { PageHeading, Input, Select, Tooltip, Checkbox, Icon, Dropdown, Pagination, Button, ProfilePicture } from '@components'

import { useCustomer } from '@store/customer.js'
const $customer = useCustomer()

import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()

onMounted(async () => {
    await $customer.fetchCustomers()
})

const filter = ref({
    search: '',
    status: 'all',
    nameSorting: false
})

const filteredCustomer = computed(() => {
    console.log($customer.getCustomers)
    let filteredArray = $customer.getCustomers
    if (!filteredArray) return []

    // Filter by name
    // if (filter.value.nameSorting) {
    //     filteredArray.sort((a, b) => a.name.localeCompare(b.name))
    // } else {
    //     filteredArray.sort((a, b) => b.name.localeCompare(a.name))
    // }

    // Filter by status
    if (filter.value.status && filter.value.status == 'priority') {
        filteredArray = filteredArray.filter(customer => customer.meta.priority == true)
    }

    // Filter by search
    if (filter.value.search) {
        filteredArray = filteredArray.filter(customer =>
            String(customer.ucid).toLowerCase().includes(filter.value.search.toLowerCase())
            || String(customer.name).toLowerCase().includes(filter.value.search.toLowerCase())
            || String(customer.email).toLowerCase().includes(filter.value.search.toLowerCase())
            || String(customer.meta.phone).includes(filter.value.search))
    }

    return filteredArray
})

// Get paginated customers.
const currentPage = ref(1)
const perPage = ref(10)
// const sortBy = computed(() => {
//     return filter.value.nameSorting ? 'name' : 'customer_id'
// })
const sortBy = ref('customer_id')
const sortDirection = ref('DESC')

const getPaginatedCustomers = computed(() => {
    let _customers = filteredCustomer.value

    // Sort.

    if (filter.value.nameSorting) {
        _customers = _customers.sort((a, b) => a.name.localeCompare(b.name))
    } else {
        _customers = _customers ? _customers.sort((a, b) => {
            if (Number(a[sortBy.value]) < Number(b[sortBy.value])) {
                return sortDirection.value == 'ASC' ? -1 : 1
            }

            if (Number(a[sortBy.value]) > Number(b[sortBy.value])) {
                return sortDirection.value == 'ASC' ? 1 : -1
            }

            return 0
        }) : []
    }

    console.log('ok')

    return {
        total: _customers.length,
        data: _customers.slice((currentPage.value - 1) * perPage.value, currentPage.value * perPage.value)
    }
})

const subtitle = computed(() => {
    let total = filteredCustomer.value.length
    return ('Total ' + total) + ` ${String($settings.labels.customer?.singular).toLowerCase()}` + (total > 1 ? 's' : '')
})

const state = reactive({
    allCheckbox: false,
})

const toggleAllCustomers = () => {
    getPaginatedCustomers.value.data.forEach(customer => {
        return customer.meta.checkbox = state.allCheckbox
    })
}

const getSelectedCustomers = computed(() => {
    return getPaginatedCustomers.value.data.filter(customer => customer.meta.checkbox == true) || []
})


watch(getSelectedCustomers, (newValue) => {
    if (newValue.length == 0) {
        state.allCheckbox = false
    }
    else if (newValue.length == perPage.value || newValue.length == getPaginatedCustomers.value.data?.length) {
        state.allCheckbox = true
    }
    else {
        state.allCheckbox = -1
    }
})

const deleteCustomer = async (customer) => {

    const deleted = await customer.delete()

    if (deleted) {
        Toast.success(`${$settings.labels.customer?.singular} deleted successfully`)
        await $customer.fetchCustomers()
    } else {
        // Toast.error(response.message)
    }
}

const changePriority = async (customer) => {
    if (!customer.customer_id) return Toast.error(`No ${String($settings.labels.customer?.singular).toLowerCase()} id found`)
    customer.meta.priority = !customer.meta.priority

    // const response = await customer.update(customer, customer.customer_id)
    const response = await $customer.model().update(customer, customer.customer_id)

    if (response.success) {
        Toast.success(`${$settings.labels.customer?.singular} updated successfully`)
        // await $customer.fetchCustomers()
    } else {
        Toast.error(response.message)
    }
}

const deleteSelected = async (ids = null) => {
    ids = ids || getSelectedCustomers.value.map(customer => customer.customer_id)

    // Confirm
    const confirm = await Prompt.fire({
        title: `Delete ${String($settings.labels.customer?.plural).toLowerCase()}?`,
        message: `Are you sure you want to delete selected ${ids.length > 1 ? ids.length : ''} ${String($settings.labels.customer?.singular).toLowerCase()}${ids.length > 1 ? 's' : ''}?`,
        ok: 'Delete',
    })

    if (!confirm.ok) return

    await $customer.bulkDelete(ids)
    $customer.fetchCustomers()
}

</script>

<template>
    <div class="my-[-28px] md:max-w-[992px] m-auto">
        <PageHeading :title="$settings.labels.customer?.singular" :subtitle="subtitle">
            <template #rightSide>
                <router-link v-if="access('customer.add')" :to="{ name: 'customer.add' }">
                    <Button size="md" type="tertiary_color" radius="square">Add New
                        <template #before>
                            <Icon name="plusCircle" />
                        </template>
                    </Button>
                </router-link>
            </template>
        </PageHeading>

        <!-- Filter -->
        <div class="flex flex-col md:flex-row gap-3 md:gap-[52px] my-7 justify-between items-center w-full">
            <Input v-model="filter.search" class="w-full" :placeholder="`Search ${String($settings.labels.customer?.singular).toLowerCase()}`" iconLeft="searchLg"></Input>
            <Select :options="[{ label: 'All', value: 'all' }, { label: 'Priority', value: 'priority' }]" v-model="filter.status" placeholder="Status" class="w-full lg:w-[191px]"></Select>
        </div>

        <!-- Actions -->
        <Transition name="router-animation">
            <Button v-if="getSelectedCustomers.length" size="md" type="secondary_gray" radius="square" @click.prevent="deleteSelected()" class="mb-5 border-[#FDA29B] text-[#B42318]">Delete</Button>
        </Transition>

        <!-- Customer list -->
        <div class="flex overflow-scroll md:overflow-visible">
            <!-- ID column -->
            <div class="w-fit">
                <div class="text-[#667085] text-sm font-normal bg-[linear-gradient(0deg,#EAECF0,transparent)] p-[0px_1px_1px_1px]">
                    <div class="h-[38px] flex items-center gap-3 py-2.5 px-4 bg-white text-sm font-medium text-[#667085]">
                        <Checkbox v-model="state.allCheckbox" @click="toggleAllCustomers" />
                        ID
                    </div>
                </div>
                <div v-for="(customer, index) in getPaginatedCustomers.data" :key="index" class="h-[60px] flex items-center gap-3 py-[21px] px-4 hover:bg-[#F9FAFB] border border-[#EAECF0] border-y-0 last:border-b text-sm font-medium text-[#344054]">
                    <Checkbox v-model="customer.meta.checkbox"></Checkbox>
                    {{ customer.ucid }}
                </div>
            </div>

            <!-- Priority column -->
            <div class="text-center w-fit">
                <div class="text-[#667085] text-sm font-normal bg-[linear-gradient(0deg,#EAECF0,transparent)] p-[0px_0px_1px_0px]">
                    <div class="h-[38px] flex items-center gap-3 py-2.5 px-4 bg-white  text-sm font-medium text-[#667085]">
                        <div>Priority</div>
                    </div>
                </div>
                <div v-for="(customer, index) in getPaginatedCustomers.data" :key="index" class="h-[60px] py-[18.65px] px-4 border border-[#EAECF0] border-x-0 border-y-0 last:border-b">
                    <!-- <Icon @click="changePriority(customer)" name="star01" size="24px" :class="{ '!fill-[#7F56D9]': customer.meta.priority }" class="fill-none text-[#7F56D9]" /> -->
                    <svg @click="changePriority(customer)" class="inline-flex cursor-pointer text-center w-[24px] h-[24px]" :fill="customer.meta.priority ? '#7F56D9' : 'none'" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.2827 3.45332C11.5131 2.98638 11.6284 2.75291 11.7848 2.67831C11.9209 2.61341 12.0791 2.61341 12.2152 2.67831C12.3717 2.75291 12.4869 2.98638 12.7174 3.45332L14.9041 7.88328C14.9721 8.02113 15.0061 8.09006 15.0558 8.14358C15.0999 8.19096 15.1527 8.22935 15.2113 8.25662C15.2776 8.28742 15.3536 8.29854 15.5057 8.32077L20.397 9.03571C20.9121 9.11099 21.1696 9.14863 21.2888 9.27444C21.3925 9.38389 21.4412 9.5343 21.4215 9.68377C21.3988 9.85558 21.2124 10.0372 20.8395 10.4004L17.3014 13.8464C17.1912 13.9538 17.136 14.0076 17.1004 14.0715C17.0689 14.128 17.0487 14.1902 17.0409 14.2545C17.0321 14.3271 17.0451 14.403 17.0711 14.5547L17.906 19.4221C17.994 19.9355 18.038 20.1922 17.9553 20.3445C17.8833 20.477 17.7554 20.57 17.6071 20.5975C17.4366 20.6291 17.2061 20.5078 16.7451 20.2654L12.3724 17.9658C12.2361 17.8942 12.168 17.8584 12.0962 17.8443C12.0327 17.8318 11.9673 17.8318 11.9038 17.8443C11.832 17.8584 11.7639 17.8942 11.6277 17.9658L7.25492 20.2654C6.79392 20.5078 6.56341 20.6291 6.39297 20.5975C6.24468 20.57 6.11672 20.477 6.04474 20.3445C5.962 20.1922 6.00603 19.9355 6.09407 19.4221L6.92889 14.5547C6.95491 14.403 6.96793 14.3271 6.95912 14.2545C6.95132 14.1902 6.93111 14.128 6.89961 14.0715C6.86402 14.0076 6.80888 13.9538 6.69859 13.8464L3.16056 10.4004C2.78766 10.0372 2.60121 9.85558 2.57853 9.68377C2.55879 9.5343 2.60755 9.38389 2.71125 9.27444C2.83044 9.14863 3.08797 9.11099 3.60304 9.03571L8.49431 8.32077C8.64642 8.29854 8.72248 8.28742 8.78872 8.25662C8.84736 8.22935 8.90016 8.19096 8.94419 8.14358C8.99391 8.09006 9.02793 8.02113 9.09597 7.88328L11.2827 3.45332Z" :stroke="customer.meta.priority ? '#7F56D9' : '#98A2B3'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>

            <!-- Name column -->
            <div class="w-full">
                <div class="text-[#667085] text-sm font-normal bg-[linear-gradient(0deg,#EAECF0,transparent)] p-[0px_1px_1px_1px]">
                    <div class="h-[38px] flex items-center gap-3 py-2.5 px-4 bg-white  text-sm font-medium text-[#667085]">
                        <Icon @click="filter.nameSorting = !filter.nameSorting" name="switchVertical01" size="20px" :class="[filter.nameSorting ? 'text-[#323438]' : 'text-[#D0D5DD]']" class="cursor-pointer"></Icon>
                        <div>Name</div>
                    </div>
                </div>
                <div v-for="(customer, index) in getPaginatedCustomers.data" :key="index" class="h-[60px] flex gap-2 items-center py-[19px] px-4 border border-[#EAECF0] border-y-0  last:border-b text-[#344054] text-sm font-semibold">
                    <!-- <img :src="customer.meta.profile_image_url ? customer.meta.profile_image_url : 'https://1.gravatar.com/avatar/729ae85bf62b9917e93538db2f2688ca?s=96&d=mm&r=g'" class="w-[24px] h-[24px] object-cover rounded-full" /> -->
                    <!-- <div class="w-[24px] h-[24px]">
                        <div v-if="customer.meta?.profile_image_url" class="w-[24px] h-[24px] rounded-full overflow-hidden">
                            <img :src="customer.meta.profile_image_url" class="w-full h-full">
                        </div>
                        <div v-else class="bg-[#333333] text-white w-[24px] h-[24px] overflow-hidden rounded-full flex items-center justify-center uppercase text-xs font-bold">
                            {{ customer.name?.split('')[0] }}
                        </div>
                    </div> -->
                    <ProfilePicture :name="customer.name" :img="customer.meta?.profile_image_url" :bgColor="customer.meta?.color" class="w-[24px] h-[24px]" textClass="!text-[12px] leading-[normal]" />
                    <router-link v-if="access('customer.view')" class="overflow-hidden whitespace-nowrap text-ellipsis max-w-[180px]" :title="customer.name" :to="{ name: 'customer.view', params: { customerId: customer.customer_id } }">{{ customer.name || 'N/A' }}</router-link>
                </div>
            </div>

            <!-- Email column -->
            <div class="w-full">
                <div class="text-[#667085] text-sm font-normal bg-[linear-gradient(0deg,#EAECF0,transparent)] p-[0px_0px_1px_0px]">
                    <div class="h-[38px] flex items-center gap-3 py-2.5 px-4 bg-white text-sm font-medium text-[#667085]">
                        <div>Email</div>
                    </div>
                </div>
                <div v-for="(customer, index) in getPaginatedCustomers.data" :key="index" class="h-[60px] py-[21px] px-4 border border-[#EAECF0] border-x-0  border-y-0  last:border-b text-[#344054] text-sm font-medium">
                    <span class="overflow-hidden whitespace-nowrap text-ellipsis max-w-[130px]" :title="customer.email">{{ customer.email || 'N/A' }}</span>
                </div>
            </div>

            <!-- Phone column -->
            <div class="w-full">
                <div class="text-[#667085] text-sm font-normal bg-[linear-gradient(0deg,#EAECF0,transparent)] p-[0px_1px_1px_1px]">
                    <div class="h-[38px] flex items-center gap-3 py-2.5 px-4 bg-white text-sm font-medium text-[#667085]">
                        <div>Phone</div>
                    </div>
                </div>
                <div v-for="(customer, index) in getPaginatedCustomers.data  " :key="index" class="h-[60px] flex justify-between items-center text-nowrap py-[17px] px-4 border border-[#EAECF0] border-y-0  last:border-b text-[#344054] text-sm font-medium">
                    <span class="overflow-hidden whitespace-nowrap text-ellipsis max-w-[120px]" :title="customer.meta.phone">{{ customer.meta.phone || 'N/A' }}</span>

                    <!-- actions -->
                    <div class="flex items-center gap-4">

                        <Tooltip :title="`Create ${String($settings.labels.appointment?.singular).toLowerCase()}`" positionX="left">
                            <router-link v-if="access('appointment.add')" :to="{ name: 'appointment.add', query: { customerId: customer.customer_id, backTo: route.fullPath } }" class="relative group">
                                <Icon name="plusCircle" size="24px" class="text-[#98A2B3]" />
                            </router-link>
                        </Tooltip>

                        <Dropdown :contentClass="`w-56 top-[35px] top-[35px] w-[117px] z-[9] ${$settings.isRTL ? ' left-0' : 'right-0'}`">
                            <Icon name="dotsVertical" size="28px" class="text-[#98A2B3] rounded hover:bg-[#F2F4F7] cursor-pointer" />

                            <template #content>
                                <div class="flex flex-col gap-1">
                                    <div class="rounded-md mx-1.5 my-0.5 transition">
                                        <router-link v-if="access('customer.view')" :to="{ name: 'customer.view', params: { customerId: customer.customer_id }, query: { backTo: route.fullPath } }" class="px-2.5 py-[9px] flex gap-2 items-center hover:bg-[#F9FAFB] rounded-md cursor-pointer transition-all duration-300">
                                            <Icon size="16px" name="infoCircle" />
                                            <div class="text-[#344054] text-sm font-medium">Details</div>
                                        </router-link>
                                    </div>
                                    <div class="rounded-md mx-1.5 my-0.5 transition">
                                        <router-link v-if="access('customer.edit')" :to="{ name: 'customer.edit', params: { customerId: customer.customer_id }, query: { backTo: route.fullPath } }" class="px-2.5 py-[9px] flex gap-2 items-center hover:bg-[#F9FAFB] rounded-md cursor-pointer transition-all duration-300">
                                            <Icon size="16px" name="edit05" />
                                            <div class="text-[#344054] text-sm font-medium">Edit</div>
                                        </router-link>
                                    </div>
                                    <div class="rounded-md mx-1.5 my-0.5 transition">
                                        <div class="px-2.5 py-[9px] flex gap-2 items-center hover:bg-[#F9FAFB] rounded-md cursor-pointer transition-all duration-300">
                                            <Icon size="16px" name="trash01" />
                                            <div @click="deleteCustomer(customer)" class="text-[#344054] text-sm font-medium">Delete</div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="getPaginatedCustomers.total == 0">
            <p class="p-4 my-4 italic text-center text-gray-700 border-gray-400 rounded-lg bg-gray-50">No customer found</p>
        </div>
        <Pagination v-if="getPaginatedCustomers.total !== 0" class="pt-[20px]" v-model:currentPage="currentPage" :totalItems="getPaginatedCustomers.total" :itemsPerPage="perPage"></Pagination>

    </div>
</template>